
import { defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { IEventManagements } from "@/interfaces/iEventManagement";
import EventDetail from "@/views/eventManagement/views/EventDetail.vue";

export default defineComponent({
  emit: ["close-detail"],
  name: "event-detail-modal",
  components: { VZModal, EventDetail },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<IEventManagements>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };

    return {
      close,
      t,
    };
  },
});
